//
// Webasyst AuthAdapters
//

( function($, waTheme) {

    $.ajaxSetup({
        cache: false
    });

    var ProfilePage = ( function($) {

        ProfilePage = function(options) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.locales = options["locales"];

            // VARS

            // DYNAMIC VARS
            that.is_locked = false;
            that.xhr = false;

            // INIT
            that.initClass();
        };

        ProfilePage.prototype.initClass = function() {
            var that = this;

            that.initEditProfile();
        };

        ProfilePage.prototype.initEditProfile = function() {
            var that = this,
                $wrapper = that.$wrapper.find(".js-form-wrapper");

            if (!$wrapper.length) { return false; }

            var ProfileSection = ( function($) {

                ProfileSection = function(options) {
                    var that = this;

                    // DOM
                    that.$wrapper = options["$wrapper"];
                    that.$editBlock = that.$wrapper.find(".js-edit-block");
                    that.$viewBlock = that.$wrapper.find(".js-view-block");
                    that.$passwordField = that.$editBlock.find(".wa-field-password");
                    that.$photoField = that.$editBlock.find(".wa-field-photo");

                    // VARS
                    that.locales = options["locales"];

                    // DYNAMIC VARS

                    // INIT
                    that.initClass();
                };

                ProfileSection.prototype.initClass = function() {
                    var that = this;
                    //
                    that.initBlockToggle();
                    //
                    if (that.$passwordField.length) {
                        that.initChangePassword();
                    }
                    //
                    if (that.$photoField.length) {
                        that.initPhotoSection();
                    }
                };

                ProfileSection.prototype.initBlockToggle = function() {
                    var that = this;

                    // show Edit Form
                    that.$wrapper.on("click", ".js-show-edit-form", function(event) {
                        event.preventDefault();
                        toggle(true);
                    });

                    // hide edit Form
                    that.$wrapper.on("click", ".js-reset-form", function(event) {
                        event.preventDefault();
                        that.$wrapper.trigger("onReset");
                        toggle(false);
                    });

                    /**
                     * @param {Boolean} show
                     * */
                    function toggle(show) {
                        if (show) {
                            that.$viewBlock.hide();
                            that.$editBlock.show();

                        } else {
                            that.$editBlock.hide();
                            that.$viewBlock.show();
                        }
                    }
                };

                ProfileSection.prototype.initChangePassword = function() {
                    var that = this,
                        $password = that.$passwordField,
                        $passwordBlock = $password.find("p"),
                        $changeLink = $("<a class=\"s-button s-change-password-button js-change-password\" href=\"javascript:void(0);\">" + that.locales["changePasswordText"] + "</a>").hide(),
                        hidden_class = "is-hidden",
                        is_changed = false;

                    // Render
                    $password.find('.wa-value').prepend($changeLink);

                    $changeLink.on("click", function(event) {
                        event.preventDefault();
                        toggle(true);
                    });

                    var $viewChangePassword = that.$viewBlock.find(".js-change-password-force").show();
                    $viewChangePassword.on("click", function(event) {
                        event.preventDefault();

                        that.$wrapper.find(".js-show-edit-form").trigger("click");
                        toggle(true);
                        setTimeout(function() {
                            $(window).scrollTop($password.offset().top);
                        }, 100)
                    });

                    toggle(false);

                    that.$wrapper.on("onReset", function() {
                        if (is_changed) {
                            toggle(false);
                        }
                    });

                    /**
                     * @param {Boolean} show
                     * */
                    function toggle(show) {
                        if (show) {
                            $changeLink.hide();
                            $passwordBlock.removeClass(hidden_class);

                        } else {
                            $changeLink.show();
                            $passwordBlock.addClass(hidden_class);
                        }

                        is_changed = show;
                    }
                };

                ProfileSection.prototype.initPhotoSection = function() {
                    var that = this,
                        $photo = that.$photoField,
                        $delete_photo_link = $("<a class=\"js-delete-photo\" href=\"javascript:void(0);\">" + that.locales["deletePhotoText"] + "</a>"),
                        $delete_link_wrapper = $("<p />").append($delete_photo_link),
                        $photo_input = $photo.find('[name="profile[photo]"]'),
                        $user_photo = $photo.find('img:first'),
                        $default_photo = $photo.find('img:last'),
                        photo_input_val = $photo_input.val(),
                        is_changed = false;

                    if ($user_photo[0] !== $default_photo[0]) {
                        $default_photo.hide()
                            .after($delete_link_wrapper);

                        $delete_photo_link.on("click", function(event) {
                            event.preventDefault();
                            toggle(true);
                        });

                    } else {
                        $default_photo.show();
                    }

                    that.$wrapper.on("onReset", function() {
                        if (is_changed) {
                            toggle(false);
                        }
                    });

                    /**
                     * @param {Boolean} show
                     * */
                    function toggle(show) {
                        if (show) {
                            $user_photo.hide();
                            $default_photo.show();
                            $delete_photo_link.hide();
                            $photo_input.val('');
                        } else {
                            $user_photo.show();
                            $default_photo.hide();
                            $delete_photo_link.show();
                            $photo_input.val(photo_input_val);
                        }

                        is_changed = show;
                    }
                };

                return ProfileSection;

            })($);

            new ProfileSection({
                $wrapper: $wrapper,
                locales: that.locales
            });
        };

        return ProfilePage;

    })($);

    waTheme.init.site.ProfilePage = ProfilePage;

    var $profilePage = $("#js-profile-page");
    if ($profilePage.length) {
        new window.waTheme.init.site.ProfilePage({
            $wrapper: $profilePage,
            locales: {
                "changePasswordText": window.waTheme.locale.changePasswordText,
                "deletePhotoText":  window.waTheme.locale.deletePhotoText,
            }
        });
    }

})(jQuery, window.waTheme);
